module.exports = __webpack_public_path__ + "static/media/logoff.712b5c88.png";